import type { Page, TrailerListQuery } from '@chukua/common';
import { Table, type TableColumnsType } from 'antd';
import { SearchX } from 'lucide-react';
import { EmptyState } from '../../../../../shared/components/EmptyState';
import { ListSearch } from '../../../../../shared/components/ListSearch';
import type { ListQueryControls } from '../../../../../shared/hooks/use-list-query';
import type { TrailerListItem } from '../trailers.api';

interface TrailersTableProps {
  page: Page<TrailerListItem>;
  columns: TableColumnsType<TrailerListItem>;
  list: ListQueryControls<TrailerListQuery>;
  isRefreshing: boolean;
}

/** Search box plus the server-paged table; the old rows stay up, dimmed, while the next page loads. */
export function TrailersTable({ page, columns, list, isRefreshing }: TrailersTableProps) {
  return (
    <div className="flex flex-col gap-4">
      <ListSearch value={list.query.q} placeholder="Search registration" onSearch={(q) => list.setQuery({ q }, { replace: true })} />
      <Table
        rowKey="id"
        dataSource={page.items}
        columns={columns}
        loading={isRefreshing}
        scroll={{ x: 'max-content' }}
        locale={list.isFiltered ? { emptyText: <NoMatchingTrailers /> } : undefined}
        {...list.tableProps<TrailerListItem>(page.total)}
      />
    </div>
  );
}

function NoMatchingTrailers() {
  return <EmptyState icon={SearchX} title="No matching trailers" description="No trailers match this search or these filters." />;
}
